import React, { ChangeEvent, FC } from 'react';
import { useAppDispatch } from 'app/hooks';
import { Box, Grid, Slider, TextField, Typography } from '@mui/material';
import { selectedElement, updateContentElementById } from 'features/document/documentSlice';
import { isSpacerElement } from 'utils/typeGuards';
import { Subtitle, Title } from '../../Sidebar.styled';

interface Props {
  currentElement: selectedElement;
}

const SpacerSidebar: FC<Props> = ({ currentElement }) => {
  if (!isSpacerElement(currentElement.data)) {
    return null;
  }

  const dispatch = useAppDispatch();
  const { height } = currentElement.data.content;

  const handleUpdateHeight = (event: ChangeEvent<HTMLInputElement>) => {
    const regex = /^[0-9\b]+$/;
    let value = event.target.value;
    if (value === '' || regex.test(value)) {
      if (Number(value) < 10) value = '10';
      if (Number(value) > 500) value = '500';
      dispatch(
        updateContentElementById({
          content: {
            height: value,
          },
          style: {},
        })
      );
    }
  };

  const handleUpdateHeightWithSlider = (_event: Event | ChangeEvent<HTMLInputElement>, value: number | number[]) => {
    if (typeof value === 'number') {
      dispatch(
        updateContentElementById({
          content: {
            height: value,
          },
          style: {},
        })
      );
    }
  };

  return (
    <Grid container sx={{ width: '100%' }} gap={2}>
      <Grid item xs={12}>
        <Title>Spacer Block</Title>
      </Grid>

      <Grid item xs={12}>
        <Subtitle>Height</Subtitle>
        <Box alignItems='center' display='flex'>
          <Slider
            size='small'
            min={10}
            value={height}
            max={500}
            aria-label='Small'
            valueLabelDisplay='off'
            onChange={handleUpdateHeightWithSlider}
            sx={{ '.MuiSlider-thumb': { boxShadow: 'none' } }}
          />

          <Box display='flex' alignItems='center'>
            <TextField
              name='heightInput'
              placeholder='Set Height'
              sx={{
                margin: '0 5px 0 20px',
                width: '60px',
                '& .MuiOutlinedInput-root': {
                  borderRadius: '8px',
                  height: '48px',
                },
              }}
              value={height}
              onChange={handleUpdateHeight}
            />

            <Typography>px</Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
};

export default SpacerSidebar;
